<button *ngIf="this.getType() === ButtonType.Button" 
        [ngStyle]="{'width': getButtonWidth()}"
        [class]="this.getEffectiveClass()"
        [id]="this.getId()">

    <!-- standard button -->
    <div *ngIf="!hasIcon()" class="w-100 h-100">
        <span class="bs-main-and-action w-100 h-100 th-btn-border d-flex justify-content-center align-items-center"
            [ngClass]="getButtonClass()"
            [id]="this.getId() + '_button_text'"
            (mouseenter)="isHovered = true" (mouseleave)="isHovered = false">
        {{buttonText}}
        </span>
    </div>

    <!-- button with icon -->
    <div *ngIf="hasIcon()" class="h-100 w-100"
         (mouseenter)="isHovered = true" (mouseleave)="isHovered = false">
        <div class="d-flex position-relative h-100 w-100">
            <span class="bs-main-and-action button-icon-text-container d-flex justify-content-center align-items-center"
                [ngClass]="getButtonWithIconClass()"
                [id]="this.getId() + '_button_text'"
                >
                {{buttonText}}
            </span>
            <div class="line" *ngIf="showLine()"></div>
            <div class="icon-container button-icon-container d-flex justify-content-center align-items-center"
                 [ngClass]="getIconClass()">
                <i [class]="icon + ' ' + getIconColor()"></i>
            </div>
        </div>
    </div>
</button>
<button *ngIf="this.getType() === ButtonType.Card"
        [ngStyle]="{'width': getButtonWidth()}"
        [class]="'button-card ' + this.getEffectiveClass()"
        [id]="this.getId()">
    <div class="w-100 h-100 d-flex justify-content-center align-items-center">

        <!-- icon -->
        <div class="h-100 icon-container"
             [ngClass]="getButtonClass()">
            <div class="h-100 d-flex justify-content-center align-items-center">
                <i [class]="icon" class="th-text-white"></i>
            </div>
        </div>

        <!-- content -->
        <div class="h-100 content-container d-flex"
            [ngStyle]="{ 'cursor' : this.getDisabled() ? 'not-allowed' : 'pointer'}">
            <div class="h-100 content d-flex flex-column">
                <div class="bs-h2 th-text-main">{{this.getButtonText()}}</div>
                <div class="mt-1" 
                    [innerHTML]="this.getDescription()">
                </div>
            </div>
        </div>
    </div>
</button>
<div *ngIf="this.getType() === ButtonType.Icon && !this.getHidden()" class="d-flex justify-content-center align-items-center">
    <div class="d-flex flex-column align-items-center icon-button-type position-relative"
        (mouseover)="onHover(true)" 
        (mouseout)="onHover(false)"
        (click)="onClick($event)">
        <i [class]="this.getIcon() + ' ' + this.getButtonIconColor()"></i>
        <span class="icon-paragraph th-text-gray-paragraphs m-0 p-0 mt-2" *ngIf="this.getButtonText().length > 0">{{this.getButtonText()}}</span>

        <!-- tooltip window -->
        <div class="tooltip-message-window th-bg-dark-gray" *ngIf="this.isHovered && this.getTooltip()">
            <span class="th-text-white bs-paragraph p-0">{{this.getTooltip()}}</span>
        </div>
    </div>
</div>

<!-- card overview  -->
<div *ngIf="this.getType() === ButtonType.CardOverview"
        [ngStyle]="{'width': getButtonWidth()}"
        class="button-CardOverview"
        (click)="this.onClick()"
        [id]="this.getId()">
    <div class="w-100 h-100 d-flex">

        <!-- icon -->
        <div class="icon-container-overview">
            <div class="h-100 d-flex justify-content-center align-items-center icon-background-container"  [ngClass]="{
                'th-bg-main' : this.getButtonColor() === ButtonColor.Primary,
                'th-bg-secondary' : this.getButtonColor() === ButtonColor.Secondary,
                'th-bg-alert' : this.getButtonColor() === ButtonColor.Danger,
                'th-bg-border-line-background' : this.getButtonColor() === ButtonColor.Default
            }">
                <i class="{{this.getIcon()}} fa-lg" aria-hidden="true" [ngClass]="{
                    'th-text-border' : this.getButtonColor() !== ButtonColor.Default, 
                    'th-text-main' : this.getButtonColor() === ButtonColor.Default
                }"></i> <!--Si el buton es distinto de default, entonces el icono debe pintarse blanco -->
            </div>
        </div>

        <!-- content -->
        <div class="h-100 content-container-overview ly-space-container d-flex align-items-center">
            <div class="h-100 content d-flex flex-column main-text-container justify-content-center">
                    <div class="bs-h2 th-text-main d-flex align-items-center">{{this.getButtonText()}}<div *ngIf="this.getShowRedDot()" class="s-red-dot"></div></div>
                    <div class="d-flex tag-description-container">      
                <div class="bs-paragraph th-text-gray-paragraphs button-description"
                *ngIf="this.getTag() === null || this.getTag() ===''"
                >{{this.getDescription()}}
                </div>
                <div class="tag-description"
                    *ngIf="this.getTag() !== null && this.getTag()!==''"
                    [ngClass]="{
                    'th-bg-main' : this.getTagColor() === TagColor.Primary,
                    'th-bg-secondary' : this.getTagColor() === TagColor.Secondary,
                    'th-bg-alert' : this.getTagColor() === TagColor.Danger,
                    'th-bg-confirmation' : this.getTagColor() === TagColor.Success
                }">{{this.getTag()}}</div>
                    </div>
            </div>
            <div class="h-100 content d-flex flex-column description-container justify-content-center">
                <div class="bs-paragraph th-text-gray-paragraphs button-description"
                *ngIf="this.getTag() !== null && this.getTag()!==''">{{this.getDescription()}}</div>
                <div class="bs-h2 th-text-main description-value">{{this.getDescriptionValue()}}</div>
            </div>
        </div>
            <i class="fa fa-chevron-right fa-lg d-flex ly-sp-s-right align-items-center" aria-hidden="true"></i>
    </div>
</div>
